import { AssetField, Filter } from '@elementary/common-ui/services/gql/types';
import { capitalize } from '@elementary/common-ui/utils/common';
import { GroupTitleFormatters } from 'shared/types';

export const COLUMN_TO_FIELD_MAP: Record<string, AssetField> = {
  name: 'NAME',
  assetType: 'DISPLAY_TYPE',
  owners: 'OWNER',
  tags: 'TAG',
  path: 'PATH',
  lastRunAt: 'LAST_EXECUTION_TIME',
  lastRunStatus: 'LAST_EXECUTION_STATUS',
  lastDataModificationTime: 'LAST_DATA_MODIFICATION_TIME',
  usage: 'TABLE_USAGE_PERCENTILE',
  materialization: 'BUILD_STRATEGY',
  isCritical: 'IS_CRITICAL',
  artifactType: 'ARTIFACT_TYPE',
  description: 'DESCRIPTION',
  dbName: 'DATABASE_NAME',
  schemaName: 'SCHEMA_NAME',
};

export const FIELD_TO_COLUMN_MAP: Partial<Record<AssetField, string>> =
  Object.fromEntries(
    Object.entries(COLUMN_TO_FIELD_MAP).map(([column, field]) => [
      field,
      column,
    ]),
  );

export const HIDDEN_CHILD_TYPES = new Set([
  'workbook',
  'element',
  'insight',
  'cell',
  'chart_tile',
  'sql_chart_tile',
]);

export const HIDDEN_CHILD_TYPES_FILTER: Filter = {
  property: 'DISPLAY_TYPE',
  operator: 'notEquals',
  value: [...HIDDEN_CHILD_TYPES],
};

const keepValue = (value: string) => value;

export const GROUP_TITLE_FORMATTERS: GroupTitleFormatters = {
  assetType: capitalize,
  artifactType: capitalize,
  materialization: capitalize,
  isCritical: (value) => (value === 'true' ? 'Critical Asset' : 'Not Critical'),
  lastRunStatus: capitalize,
  dbName: keepValue,
  schemaName: keepValue,
};

export const GROUPABLE_COLUMN_IDS = Object.keys(GROUP_TITLE_FORMATTERS);
